module.exports = __webpack_public_path__ + "images/emoji/bomb.f58169aad54511430442.png";